import { Navigate, Outlet, useLocation } from 'react-router';

import { useSessao } from '@/features/autenticacao/useSessao';

/**
 * Exige sessao ativa para as rotas filhas.
 *
 * ISTO NAO E SEGURANCA. E navegacao: o servidor recusa qualquer requisicao sem
 * token valido, e a politica de fallback dele nega por padrao. O guarda aqui
 * existe para o usuario nao ver uma tela vazia cheia de 401.
 *
 * Guarda a rota pretendida em `state.de` para devolver o usuario ao lugar depois
 * do login. Sem isso, quem abre um link direto de uma acao cai no painel e tem de
 * procurar de novo o que estava tentando ver.
 */
export function RotaProtegida() {
  const { autenticado, deveTrocarSenha, restaurando } = useSessao();
  const local = useLocation();

  /*
    "Ainda nao sei" nao e "nao autenticado". O refresh token vive em cookie
    HttpOnly e a unica forma de saber se ele vale e perguntar ao servidor. Tratar
    esse intervalo como ausencia de sessao mandaria para o login quem apenas
    recarregou a pagina — e a tela de login apareceria e desapareceria.
  */
  if (restaurando) {
    return <p role="status">Restaurando sua sessão...</p>;
  }

  if (!autenticado) {
    return <Navigate to="/login" replace state={{ de: local.pathname + local.search }} />;
  }

  // Senha definida por administrador: a troca vem antes de qualquer uso. O
  // proprio caminho de troca fica de fora, senao o redirecionamento se repetiria
  // contra ele mesmo.
  if (deveTrocarSenha && local.pathname !== '/trocar-senha') {
    return <Navigate to="/trocar-senha" replace />;
  }

  return <Outlet />;
}
